import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/user-management/manage-alerts/index.html';

const links: Record<string, string> = {
  saved: '/infoTrac/user-management/manage-settings-saved',
};

function UserManagementManageAlerts() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const saved = iframeDocument.getElementById('save-settings');

      if (saved) saved.addEventListener('click', () => navigate(links.saved));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="user-management-manage-alerts" src={path} width="100%" height="1000px" />;
}

export default UserManagementManageAlerts;
